/**
 * Copyright Highway9 Networks Inc.
 */
import { Icons } from "../components/GraphicalResources";
import { text } from "../components/TextResources";
import { authenticationService } from "../services";

import type { JSX } from "react";

export const TENANTS = "/tenants";
export const ORDER_MANAGEMENT = "/orderManagement";
export const VIRTUAL_MOBILITY_CLOUDS = "/";
export const SERVICE_REPORT = "/serviceReport";
export const HARDWARE_MANAGEMENT = "/hardwareManagement";
export const SOFTWARE_RELEASE = "/softwareRelease";
export const SIM_MANAGEMENT = "/simManagement";
export const ECI_MANAGEMENT = "/eciManagement";
export const USER_MANAGEMENT = "/userManagement";
export const AUDITLOGS = "/auditLogs";
export const ADMINISTRATION = "/administration";
export const LICENSE_AGREEMENT = "/eula";
export const API_DOCS = "/api/v1/saas/docs";
export const DOCUMENTATION = "https://highway9networks.freshdesk.com/a/solutions";
export const SUPPORT = "https://support.highway9networks.com/";

type Route = {
  name: string;
  path: string;
  icon: JSX.Element;
  hidden?: boolean;
  dividerAfter?: boolean;
};
// Changed this to function to update the hidden value without reload the page
export const routes = () =>
  [
    {
      name: text.tenants!,
      path: TENANTS,
      icon: Icons.tenant,
      hidden: !(authenticationService.isOperator() || authenticationService.isSystemEngineerOrMspAdmin()),
    },
    {
      name: text.orderManagement!,
      path: ORDER_MANAGEMENT,
      icon: Icons.orderManagement,
      hidden: !authenticationService.isOperator() && !authenticationService.isSystemEngineerOrMspAdmin() && !authenticationService.isTenant(),
    },
    {
      name: text.VMCs!,
      path: VIRTUAL_MOBILITY_CLOUDS,
      icon: Icons.serviceInstance,
      dividerAfter: true,
    },
    {
      name: text.hardwareManagement!,
      path: HARDWARE_MANAGEMENT,
      icon: Icons.hardwareInventory,
      hidden: !authenticationService.isOperator(),
    },
    {
      name: text.releases!,
      path: SOFTWARE_RELEASE,
      icon: Icons.application,
      hidden: !authenticationService.isOperator(),
    },
    {
      name: text.simManagement!,
      path: SIM_MANAGEMENT,
      icon: Icons.simManagement,
      hidden: !authenticationService.isOperator(),
    },
    {
      name: text.ECIManagement!,
      path: ECI_MANAGEMENT,
      icon: Icons.ECIManagement,
      hidden: !authenticationService.isOperator(),
      // MCS-3870: SideDrawer now collapses hidden routes' dividers, so no role condition needed here.
      dividerAfter: true,
    },
    {
      name: text.serviceReport!,
      path: SERVICE_REPORT,
      icon: Icons.report,
      hidden: !authenticationService.isOperator(),
      dividerAfter: true,
    },
    {
      name: text.Administration!,
      path: ADMINISTRATION,
      icon: Icons.Administration,
      // Whitelist mirroring AdministrationPanel's tab gating: every tab is operator-only except
      // Tenant Config (tenant, non-MCA). Any role outside this set gets a blank page — previously
      // this was a blacklist that had to be patched per-role (MCA, then MSP via MCS-3538, then
      // KPI partners again) each time a new role hit the empty page.
      hidden: !(
        authenticationService.isOperator() ||
        (authenticationService.isTenant() && !authenticationService.isMobileCenterAdmin())
      ),
    },
    {
      name: text.userManagement!,
      path: USER_MANAGEMENT,
      icon: Icons.userManagement,
      // Whitelist: operators (Users + Roles tabs), non-MCA tenants (manage tenant users),
      // SE/MSP partner admins (manage users of their managed tenants — MCS-1696), and
      // RAN partner admins (have full user CRUD in the backend).
      hidden: !(
        authenticationService.isOperator() ||
        authenticationService.isSystemEngineerOrMspAdmin() ||
        authenticationService.isRanPartnerAdmin() ||
        (authenticationService.isTenant() && !authenticationService.isMobileCenterAdmin())
      ),
    },
    {
      name: text.auditLog!,
      path: AUDITLOGS,
      icon: Icons.logs,
    },
  ] as Route[];
